import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/instances';
import { actionCreators as actionCreatorsContacts } from '../actions/contacts';
import InstancesTableItem from './InstancesTableItem';
import '../styles/InstancesTable.css';

import {
  Table,
  TableHead,
  TableBody
} from "@material-ui/core";

class InstancesTableComponent extends Component {

 
  componentDidMount() {
    this.props.requestContacts();
  }

  onNotificationChange = (instance) => {
    this.props.editInstance(instance);
  }

  onRemove = (id) => {
    this.props.removeInstance(id);
  };

  onAddInstance = () => {
    this.props.history.push("/create");
  };

  renderInstancesTable = (props) => {
    return (
      <div>
        <Table style={{margin: '0 auto', width: '95%'}} className="mb-0">
          <TableHead>
            <tr
              style= {
                {
                  fontSize: '1.3rem'
                }}
            >
              <th>Client Name</th>
              <th>URL</th>
              <th>Contact Details</th>
              <th>Well Test Delay</th>
              <th>% Analysable Tests</th>
              <th>% Incomplete Tests</th>
              <th>% Wells Running</th>
              <th>% Wells Shutdown</th>
              <th>% Wells Comms. Failure</th>
              <th>% Wells Comms. Failure<br/>Manufacturers</th>
              <th>Check Time for Well Updates<br/>(0: No Updates)</th>
              <th>Check Time for Installation Updates<br/>(0: No Updates)</th>
              <th>Has ESP Wells</th>
              <th>Has GL Wells</th>
              <th>Notifications</th>
              <th>Action</th>
            </tr>
          </TableHead>
          <TableBody>
            {props.instances.map(i =>
              <InstancesTableItem key={i.id} instance={i} contact={this.props.contacts} remove={this.onRemove} notificationChange={this.onNotificationChange}/>
            )}
          </TableBody>
        </Table>
      </div>
    );
  };

  render() {
    return (
      <div>
        <h1 className='InstanceH1'>Instances</h1>
        <button className="ui button instances-page-button" onClick={this.onAddInstance}>Create New</button>
        <br/>
        {this.renderInstancesTable(this.props)}
      </div>
    );
  };
}

const mapDispatchToProps = (dispatch, props) => ({
  requestInstances: () => dispatch(actionCreators.requestInstances()),
  removeInstance: (id) => dispatch(actionCreators.removeInstance(id)),
  editInstance: (instance) => dispatch(actionCreators.editInstance(instance)),
  requestContacts: () => dispatch(actionCreatorsContacts.requestContacts())
});

const mapStateToProps = state => {
  return {
      instances: state.instances.instances,
      contacts: state.contacts.contacts
  };
}

const InstancesTable = connect(
  mapStateToProps,
  mapDispatchToProps
)(InstancesTableComponent);

export default InstancesTable;


// WEBPACK FOOTER //
// ./src/components/InstancesTable.js